export const STORAGE_KEY_AUTH_STATUS = 'auth:status';
export const STORAGE_KEY_APP_VERSION = 'app:version';
export const STORAGE_KEY_APP_BACKGROUND_AT = 'app:background-at';
export const STORAGE_KEY_USER_LAST_ACTIVITY = 'user:last-activity';
